import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import lodash from 'lodash'
import BootstrapVue from 'bootstrap-vue'
import CKEditor from '@ckeditor/ckeditor5-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/mixins';
import '@/vee-validate'
import VueMeta from 'vue-meta'
import { i18n } from './translate'
import VueSweetalert2 from 'vue-sweetalert2';
import VueCountdownTimer from 'vuejs-countdown-timer';

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.use(VueSweetalert2);
Vue.use(VueMeta)
Vue.use(VueCountdownTimer);

Vue.use(BootstrapVue)
Vue.prototype._ = lodash
Vue.use(CKEditor);

import '@/helpers/common-components.js';
Vue.config.productionTip = false
const EventBus = new Vue()
Object.defineProperties(Vue.prototype, {
  $eventHub: {
    get: function () {
      return EventBus
    }
  }
})

const defaultLang = 'en'
// Vue.prototype.$eventHub = new Vue();
new Vue({
  i18n,
  router,
  store,
  created () {
    setTimeout(() => {
      if (this.$route.query.lang in i18n.messages) {
        // this.$i18n.locale = this.$route.query.lang
      } else if (defaultLang) {
        this.$i18n.locale = defaultLang
      }
    }, 1000)
  },
  render: h => h(App)
}).$mount('#app > div')
